<template>
    <div class="selector"
         v-bind:class="{'is-inline': isInline}"
         v-on-clickaway="closeDropdown"
    >
        <div class="selector__value"
             v-if="!isInline"
             v-on:click="toggleDropdown"
        >
            <svg v-if="false && value && value.flag" v-bind:class="'bbrc-flag bbrc-flag-' + value.value"></svg>
            <img class="selector__value__icon"
                 v-bind:alt="value.name"
                 v-bind:src="'/img/' + value.icon"
                 v-if="value && value.icon"
            />
            <span class="selector__value__name" v-if="value">{{ value.name }}</span>
            <span v-else>{{ placeholder }}</span>
            <span class="selector__caret">
                <span class="jam jam-chevron-down" v-if="!isDropdownActive"></span>
                <span class="jam jam-chevron-up" v-if="isDropdownActive"></span>
            </span>
        </div>
        <div class="selector__dropdown" v-if="isDropdownActive || isInline">
            <input class="selector__dropdown__control" type="text"
                   v-if="hasAutocomplete"
                   v-model="search"
            />
            <nav class="selector__dropdown__results" v-if="results.length > 0">
                <a class="selector__dropdown__result"
                   v-for="result in results"
                   v-on:click="setValue(result)"
                >
                    <input class="has-margin-r5" type="checkbox"
                           v-bind:value="result"
                           v-if="multipleSelect && controlType === 'checkbox'"
                           v-model="checkedItems"
                    >
                    <svg v-if="false && result && result.flag" v-bind:class="'bbrc-flag bbrc-flag-' + result.value"></svg>
                    <img class="selector__dropdown__result__icon"
                         v-bind:alt="result.name"
                         v-bind:src="'/img/' + result.icon"
                         v-if="result.icon"
                    />
                    <span v-if="multipleSelect" class="selector__dropdown__result__name">{{ result.name }}</span>

                    <label class="form__radio" v-if="!multipleSelect && controlType === 'radio'">
                        <input class="has-margin-r5" type="radio"
                               v-bind:value="result"
                               v-model="checkedItems">
                        {{ result.name }}
                    </label>
                </a>
            </nav>
        </div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        computed: {
            results: function () {
                let results = this.values;

                if (this.search.length > 0) {
                    results = this.values.filter(function (value) {
                        return value.name.toLowerCase().startsWith(this.search.toLowerCase());
                    }.bind(this));
                }

                return results;
            },
            returnValue: function () {
                return this.value;
            }
        },
        created: function () {
            // attach event listeners
            eventBus.$on('selector-reset', this.reset);
        },
        data: function () {
            return {
                checkedItems: [],
                isDropdownActive: false,
                search: ''
            }
        },
        methods: {
            closeDropdown: function () {
                this.isDropdownActive = false;
            },
            reset: function () {
                console.log('reset');
                this.checkedItems = [];
            },
            setValue: function (value) {
                if (this.multipleSelect) {
                    if (this.checkedItems.includes(value)) {
                        this.checkedItems = this.checkedItems.filter(function (item) {
                            return item != value;
                        });
                    } else {
                        this.checkedItems.push(value);
                    }
                    this.$emit('input', this.checkedItems);
                }
                else {
                    this.$emit('input', value);
                }
            },
            toggleDropdown: function () {
                this.isDropdownActive = !this.isDropdownActive;
            }
        },
        mixins: [
            clickaway
        ],
        props: {
            isInline: {
                default: false,
                type: Boolean
            },
            hasAutocomplete: {
                default: false,
                type: Boolean
            },
            multipleSelect: {
                default: false,
                type: Boolean
            },
            controlType: {
                default: 'checkbox',
                type: String
            },
            placeholder: {
                default: null,
                type: String
            },
            value: {
                validator: function (value) {
                    return typeof value === 'object' || value === null;
                }
            },
            values: {
                default: null,
                type: Array
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/Selector.vue